import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { LIST_TABLE_SX } from '../../mathReports/mathTableStyles';
import { formatDate, isRegionUsed } from './regionsCalc';
import type { Region } from './regionsApi';

const DELETE_BLOCKED = 'Удалить нельзя: к региону привязаны сотрудники или терминалы. Сначала переведите их в другой регион';

interface RegionRowProps {
  item: Region;
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (item: Region) => void;
  onDelete: (item: Region) => void;
}

const RegionRow = memo(({ item, canEdit, canDelete, onEdit, onDelete }: RegionRowProps) => {
  const used = isRegionUsed(item);
  return (
    <tr>
      <td className="strong">{item.name}</td>
      <td className={item.usersCount > 0 ? 'center' : 'center muted'}>{item.usersCount}</td>
      <td className={item.terminalsCount > 0 ? 'center' : 'center muted'}>{item.terminalsCount}</td>
      <td className="muted nowrap">{formatDate(item.updatedAt)}</td>
      {(canEdit || canDelete) && (
        <td className="right nowrap">
          {canEdit && (
            <Tooltip title="Переименовать регион" enterDelay={800} arrow>
              <button type="button" className="act icon" aria-label="Переименовать регион" onClick={() => onEdit(item)}>
                <EditOutlinedIcon />
              </button>
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip title={used ? DELETE_BLOCKED : 'Удалить регион'} enterDelay={used ? 200 : 800} arrow>
              {/* span нужен, чтобы подсказка работала и на отключенной кнопке */}
              <span>
                <button
                  type="button"
                  className="act icon danger"
                  aria-label="Удалить регион"
                  disabled={used}
                  onClick={() => onDelete(item)}
                >
                  <DeleteOutlineIcon />
                </button>
              </span>
            </Tooltip>
          )}
        </td>
      )}
    </tr>
  );
});

interface RegionsTableProps {
  regions: Region[];
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (item: Region) => void;
  onDelete: (item: Region) => void;
}

const RegionsTable: React.FC<RegionsTableProps> = ({ regions, canEdit, canDelete, onEdit, onDelete }) => (
  <Box sx={LIST_TABLE_SX}>
    <table>
      <thead>
        <tr>
          <th>Название</th>
          <th className="center">Сотрудников</th>
          <th className="center">Терминалов</th>
          <th>Изменен</th>
          {(canEdit || canDelete) && <th className="right actions">Действия</th>}
        </tr>
      </thead>
      <tbody>
        {regions.map((item) => (
          <RegionRow key={item.id} item={item} canEdit={canEdit} canDelete={canDelete} onEdit={onEdit} onDelete={onDelete} />
        ))}
      </tbody>
    </table>
  </Box>
);

export default memo(RegionsTable);
